import React from 'react';
import _ from 'lodash';
import { format, isDate, addDays } from 'date-fns';

import { PaymentSummaryProps } from 'ck-website/source/components/CheckoutStages';
import { DisplayMonetaryValue } from 'ck-core-client/source/components/DisplayMonetaryValue';
import checkoutBasketArrow from 'ck-core-client/graphics/checkout/basket-arrow.svg';
import checkoutBasketGlitch from 'ck-core-client/graphics/checkout/basket-glitch.svg';
import { DATE_FORMAT } from 'ck-website/source/components/PaymentSummaryTable';
import { lang as PaymentSummaryTableLang } from 'ck-website/source/components/PaymentSummaryTable/lang';
import Icon from 'ck-core-client/source/components/Icon';
import { FRIENDLY } from 'ck-core/source/data/DateFormat';
import { lang } from './lang';
import { lang as guaranteesLang } from 'ck-website/source/components/GuaranteesBanner/lang';
import './index.less';
import { MonetaryValue } from 'ck-core/source/classes/MonetaryValue';
import { PLAN_SIZE } from 'ck-core/source/data/PlanSize';

export interface Props {
	summary: PaymentSummaryProps;
}

interface State {
	expanded: boolean;
}

export class MobilePaymentSummary extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			expanded: false
		};
	}

	render() {
		const {
			totalPrice,
			moneyBackGuarantee,
			product,
			intervalDescription,
			size,
			paymentDate,
			nextPaymentDate,
			showCancelAnytime,
			startDate,
			individualFullPrice,
			familyUpgradePrice
		} = this.props.summary;
		const { expanded } = this.state;

		const family = size === PLAN_SIZE.FAMILY;
		const fullPrice = new MonetaryValue(
			individualFullPrice.value + (family ? familyUpgradePrice.value : 0),
			individualFullPrice.currency
		);

		return (
			<div
				onClick={() => this.setState({ expanded: !expanded })}
				className={`MobilePaymentSummary MobilePaymentSummary--bottom ${
					expanded ? 'MobilePaymentSummary--expanded' : ''
				}`}
			>
				<div className="MobilePaymentSummary-initial-info">
					<div
						className={`MobilePaymentSummary__icon ${
							expanded ? 'MobilePaymentSummary__icon--expanded' : ''
						}`}
					>
						<img src={checkoutBasketArrow} />
					</div>
					<div className="MobilePaymentSummary-text">
						<div className="MobilePaymentSummary-text__product__first">
							{product.name.replace(/Coding/g, '')}
							{' - '}
							{_.upperFirst(size)}
						</div>
						<div className="MobilePaymentSummary-text__product">{intervalDescription}</div>
					</div>
					<div className="MobilePaymentSummary__money">
						<DisplayMonetaryValue value={totalPrice} />
						{fullPrice.value !== totalPrice.value && (
							<div className="MobilePaymentSummary__was">
								WAS <DisplayMonetaryValue value={fullPrice} />
							</div>
						)}
					</div>
					<div className="MobilePaymentSummary__glitch">
						<img src={checkoutBasketGlitch} />
					</div>
				</div>
				<div
					className={`MobilePaymentSummary__extra-info ${
						expanded ? 'MobilePaymentSummary__extra-info--visible' : ''
					}`}
				>
					<div className="MobilePaymentSummary__features">
						{lang.FEATURES_SUMMARY[product.id]
							.concat(
								showCancelAnytime
									? guaranteesLang.cancelAnytime.title +
									  ' - ' +
									  guaranteesLang.cancelAnytime.message
									: isDate(startDate)
										? guaranteesLang.moneyBack.title +
										  ' - ' +
										  guaranteesLang.moneyBack.message({
												to: format(addDays(startDate as Date, 30), FRIENDLY),
												from: format(startDate as Date, FRIENDLY)
										  })
										: guaranteesLang.moneyBackRedeemed.title +
										  ' - ' +
										  guaranteesLang.moneyBackRedeemed.message
							)
							.map(item => {
								return (
									<div className="MobilePaymentSummary__feature" key={item}>
										<Icon icon="CircleCheckmark" size="24" color="white" />
										<div className="MobilePaymentSummary__feature-text">{item}</div>
									</div>
								);
							})}
					</div>
					<div className="MobilePaymentSummary__reassure">
						{PaymentSummaryTableLang.PAYMENT_DATE} {format(paymentDate, DATE_FORMAT)}
						{nextPaymentDate && (
							<div className="MobilePaymentSummary__nextPayment">
								{PaymentSummaryTableLang.NEXT_PAYMENT_DATE} {format(nextPaymentDate, DATE_FORMAT)}
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}
